// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"VisuallyHidden-module__visuallyHidden-IyAo"};